import axios from "axios";

// Ensure that Laravel identifies requests from axios as AJAX requests and, for example, doesn't store them in the
// session for redirecting back to the previous page.
//
// See: https://github.com/laravel/framework/blob/e0be50a7b770c46b522377cb46318e06e312014e/src/Illuminate/Session/Middleware/StartSession.php#L200
// And: https://github.com/axios/axios/issues/1322
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
